import { transform } from './transform'

const DEFAULT_CHART_TRANSFORM = transform
const DEFAULT_CHART_TYPE = 'Line'
const DEFAULT_CHART_OPTIONS = {
  customSettings: {
    containterStyle: '',
    showSmallLegend: false,
    showInChartLegend: false,
    recalculateGridMax: false,
    chartInfoTooltip: false,
    multipleSeries: false,
    hasDrillDown: false,
    tooltip: {
      width: '120px',
      topOffset: 0,
      leftOffset: 0
    }
  },
  showGridBackground: true,
  dynamicWidth: false,
  axisX: {
    showGrid: false
  },
  axisY: {
    labelOffset: {
      x: 0,
      y: 10
    }
  },
  // low: 0,
  // high: 1000,
  chartPadding: { top: 16, right: 10, bottom: 0, left: 0 }
}

export class RenderComponent {
  constructor(chart) {
    this.chartType = chart.chartType || DEFAULT_CHART_TYPE
    this.chartData = chart.chartData || DEFAULT_CHART_TRANSFORM
    this.chartInfo = chart.chartInfo || []
    this.chartOpts = chart.chartOpts || DEFAULT_CHART_OPTIONS
    this.colors = chart.colors || {}
    this.showLegend = chart.showLegend || false
    this.showSmallLegend = chart.showSmallLegend || false
    this.showInChartLegend = chart.showInChartLegend || false
    this.components = chart.components
    this.drillDown = chart.drillDown
    this.drillDownReturn = chart.drillDownReturn
    this.customSettings = chart.chartOpts.customSettings || DEFAULT_CHART_OPTIONS.customSettings
  }
}



// WEBPACK FOOTER //
// ./src/core/charts/RenderComponent.js